import React from 'react';
import cx from 'classnames';

import './ConnectMessages.scss';

export const ConnectionString: React.FC<{ url: string; size?: 'small' | 'normal' | 'large' }> = ({
  url,
  size = 'normal',
}) => <code className={cx('connection-string', size)}>{url}</code>;
